import { Navigate } from "react-router";
import { Box, CircularProgress } from "@mui/material";
import Disputes from "../pages/Disputes";
import { useDisputesAccess } from "../hooks/useDisputesAccess";
import CompanySettingsUnavailable from "./common/CompanySettingsUnavailable";

// Gates the /disputes route. While client settings load we wait (spinner) rather
// than redirect, so an enabled client deep-linking/refreshing /disputes isn't
// wrongly bounced to /dashboard before we know they're allowed.
export default function DisputesRouteGuard() {
  const access = useDisputesAccess();

  if (access === "loading") {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (access === "error") {
    return <CompanySettingsUnavailable />;
  }

  if (access === "hidden") {
    return <Navigate to="/dashboard" replace />;
  }

  return <Disputes />;
}
